export const MoneyRequestTypeEnum = [
  { value: "", label: "Select Money Request Type" },
  { value: "LumperFee", label: "Lumper fee" },
  { value: "EscortFee", label: "Escort fee" },
  { value: "TollFee", label: "Toll fee" },
  { value: "ScaleFee", label: "Scale fee" },
  { value: "DetentionFee", label: "Detention fee" },
  { value: "LateFee", label: "Late fee" },
  { value: "CashAdvance", label: "Cash advance" },
  { value: "Fuel", label: "Fuel" },
  { value: "Repair", label: "Repair" },
  { value: "Towing", label: "Towing" },
  { value: "Equipment", label: "Equipment" },
  { value: "Washout", label: "Washout" },
  { value: "Parking", label: "Parking" },
  { value: "Reimbursement", label: "Reimbursement" },
  { value: "TruckSupplies", label: "Truck Supplies" },
  { value: "TrailerSupplies", label: "Trailer Supplies" },
  { value: "Other", label: "Other" },
];
